// src/pages/BlogPost1.jsx
import React from "react";
import Navbar from "../../components/navbar";
import Footer from "../../components/Footer";
import "./blogpost.css"; // keep your styling!

export default function BlogPost2() {
  return (
    <>
      <Navbar />
      <div className="blogpost-page medieval-root">
        <div className="blogpost-card medieval-text">
          <h1 className="blogpost-title">A note on future plans</h1>
          <span className="blogpost-date">July 26, 2025</span>
          <div className="blogpost-content">
            <p>
              This was an intense learning curve. I finished my masters 2 months ago and decided that outside of my 9-5 dev job I would start building projects. This has been really fun, but has taken 100s of hours. Future improvements and addition of new subjects will require this app to get some users, only a modest amount will do. Plans include Philosophy, Psychology etc, and achievements section with unlocks and a character you can customise/upgrade. Maybe even a PVP / champions ranked system. Sorry to some users on funky phone/pc dimensions, my bad.
            </p>
            <p>- Alex</p>

            {/* Add more content here */}
          </div>
          <a href="/blog" className="medieval-btn ghost" style={{marginTop: "1.7rem"}}>← Back to Blog</a>
        </div>
      </div>
      <Footer />
    </>
  );
}
